import { makeStyles, createStyles } from '@material-ui/styles';

export const useStyle = makeStyles(() =>
  createStyles({
    listDivider: {
      marginBottom: '5px',
      marginTop: '5px',
      '& > div': {
        margin: 0
      }
    },
    linksContainer: {
      margin: 0,
      padding: 0
    }
  })
);
